export enum CollectionPageView {
  LIST = 'list',
  GRID = 'grid'
}
